// extracted by mini-css-extract-plugin
module.exports = {"totalRow":"ProductsTab_totalRow__VOYJ6"};